import { User } from "../interfaces/user.interface";
import { OrderItem } from "../interfaces/order.interface";
import { OrdersPage } from "../components/OrdersPage";

interface OrderProps {
  user: User;
  onLogout: () => void;
  items: OrderItem[];
}

export const Order = ({ user, onLogout, items }: OrderProps) => {
  return (
    <OrdersPage user={user} onLogout={onLogout} items={items} />
  );
};
